"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DhtNodeRpcLocal = void 0;
const utils_1 = require("@streamr/utils");
const identifiers_1 = require("../identifiers");
const getClosestNodes_1 = require("./contact/getClosestNodes");
const logger = new utils_1.Logger(module);
class DhtNodeRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    // TODO rename to getClosestNeighbors (breaking change)
    async getClosestPeers(request, context) {
        this.options.addContact(context.incomingSourceDescriptor);
        const peers = (0, getClosestNodes_1.getClosestNodes)((0, identifiers_1.toDhtAddress)(request.nodeId), this.options.getNeighbors(), { maxCount: this.options.peerDiscoveryQueryBatchSize });
        const response = {
            peers,
            requestId: request.requestId
        };
        return response;
    }
    // TODO rename to getClosestRingContacts (breaking change)
    async getClosestRingPeers(request, context) {
        this.options.addContact(context.incomingSourceDescriptor);
        const closestContacts = this.options.getClosestRingContactsTo(request.ringId, this.options.peerDiscoveryQueryBatchSize);
        const response = {
            leftPeers: closestContacts.left,
            rightPeers: closestContacts.right,
            requestId: request.requestId
        };
        return response;
    }
    async ping(request, context) {
        logger.trace('received ping request: ' + (0, identifiers_1.toNodeId)(context.incomingSourceDescriptor));
        setImmediate(() => {
            this.options.addContact(context.incomingSourceDescriptor);
        });
        const response = {
            requestId: request.requestId
        };
        return response;
    }
    async leaveNotice(context) {
        // TODO check signature??
        const sender = context.incomingSourceDescriptor;
        const senderNodeId = (0, identifiers_1.toNodeId)(sender);
        logger.trace('received leave notice: ' + senderNodeId);
        this.options.removeContact(senderNodeId);
        return {};
    }
}
exports.DhtNodeRpcLocal = DhtNodeRpcLocal;
//# sourceMappingURL=DhtNodeRpcLocal.js.map